import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { MainPageClientData } from '@yandex-int/k-common/typings/api/models/main-page';

import { MainPageStoreState } from './typings';

const initialState: MainPageStoreState = {
    pages: {},
};

const initialGradePage = {
    loadingStatus: LOADING_STATUSES.LOADING,
    page: null,
};

const slice = createSlice({
    name: 'MAIN_PAGE',
    initialState: initialState,
    reducers: {
        getMainPageRequest: (state, action: PayloadAction<{ grade: number }>) => {
            const { grade } = action.payload;

            if (!state.pages[grade]) {
                state.pages[grade] = { ...initialGradePage };
            }

            state.pages[grade].loadingStatus = LOADING_STATUSES.LOADING;
        },

        getMainPageSuccess: (state, action: PayloadAction<{ grade: number; page: MainPageClientData | null }>) => {
            const { grade, page } = action.payload;

            if (!state.pages[grade]) {
                state.pages[grade] = { ...initialGradePage };
            }

            state.pages[grade].loadingStatus = LOADING_STATUSES.SUCCESS;
            state.pages[grade].page = page;
        },

        getMainPageError: (state, action: PayloadAction<{ grade: number }>) => {
            const { grade } = action.payload;

            if (!state.pages[grade]) {
                state.pages[grade] = { ...initialGradePage };
            }

            state.pages[grade].loadingStatus = LOADING_STATUSES.ERROR;
        },
    },
});

export const mainPageActions = slice.actions;
export const mainPageReducer = slice.reducer;
